import { jsx } from "react/jsx-runtime";
const DefaultHandles = ({ children }) => {
  return /* @__PURE__ */ jsx("svg", { className: "tl-user-handles tl-overlays__item", children });
};
export {
  DefaultHandles
};
//# sourceMappingURL=DefaultHandles.mjs.map
